import { Component } from '@angular/core';
import {MatDivider} from "@angular/material/divider";

import { Directive } from '@angular/core';
import {CdkScrollable} from "@angular/cdk/overlay";

@Directive({
  standalone: true,
  selector: '[articleTitle]'
})
export class ArticleTitleDirective {}

@Directive({
  standalone: true,
  selector: '[articleBody]'
})
export class ArticleBodyDirective {}

@Component({
  selector: 'app-policy-article',
  standalone: true,
  imports: [
    MatDivider,
    CdkScrollable
  ],
  templateUrl: './policy-article.component.html',
  styleUrl: './policy-article.component.scss'
})
export class PolicyArticleComponent {

}
